import type { IconProps } from './types';

export const ZapCompactIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 10, ref, ...other } = props;

  return (
    <svg width={size} height={size} viewBox="1 0.5 7.5 8.5" fill="none" ref={ref} {...other}>
      <path
        d="M5.05501 0.777679L1.59173 4.93362C1.4561 5.09638 1.38828 5.17776 1.38724 5.24649C1.38634 5.30623 1.41297 5.36308 1.45944 5.40064C1.51291 5.44384 1.61884 5.44384 1.83071 5.44384H4.66616L4.27732 8.55461L7.7406 4.39868C7.87623 4.23592 7.94405 4.15454 7.94508 4.08581C7.94599 4.02606 7.91936 3.96921 7.87288 3.93166C7.81942 3.88845 7.71349 3.88845 7.50162 3.88845H4.66616L5.05501 0.777679Z"
        fill={color}
      />
    </svg>
  );
};
